module.exports = __webpack_public_path__ + "static/wl-hero-dark-8c807fa941734638a3caba088ce1f252.png";